import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import { CustomInput, Modal, NoResult, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, PagContainer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { GROUP_COURSES_GET } from '../../../../app/redux/actions/statistics';
import SortBy from '../../SortBy';
import Pagination from '../../Pagination';
import { CourseCard, CourseCardMobile, Legend, SortingWrapper } from './style';
import { timestampToDate } from '../../../../utils/common';
import routes from '../../../../routes';

export const ModalGroupCoursesId = 'ModalGroupCourses';

const ModalGroupCourses = ({
  mediaIsPhone,
  payload,
  id,
  list,
  pager,
  getGroupCourses,
  modalClose,
}) => {
  const navigate = useNavigate();
  const scrollableAreaRef = useRef(null);
  // filters
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();

  useEffect(() => {
    if (payload.id && id === ModalGroupCoursesId) {
      getGroupCourses(selectedFilters, payload.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters, payload]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const loadMore = (page) =>
    getGroupCourses({ ...selectedFilters, page }, payload.id);
  const setItemsPerPage = (v) =>
    setSelectedFilters({ ...selectedFilters, items_per_page: v?.value });

  return (
    <Modal
      title="Percorsi formativi collegati a:"
      mbTitle={16}
      modalId={ModalGroupCoursesId}
      scrollableAreaRef={scrollableAreaRef}
      className="overflow-x-hidden"
    >
      <div style={{ margin: '0 16px' }}>
        <Text type="h2" mb={24} color="#646464">
          {payload?.name || ''}
        </Text>
        <Text type="b3" mb={32}>
          Sezione dedicata alla visualizzazione dei percorsi formativi collegati
          al gruppo selezionato. Tramite il titolo del percorso formativo è
          possibile accedere alla rispettiva area di gestione ed effettuare
          modifiche.
        </Text>
        <CustomInput
          size={mediaIsPhone ? 'full' : 'l'}
          placeholder="Cosa vuoi cercare?..."
          isSearch
          value=""
          icon="search-sm"
          isClearable
          onChange={(v) => setSearchValue(v)}
          onClickIcon={onClickSearch}
          onKeyPress={(event) => {
            if (event.key === 'Enter') onClickSearch();
          }}
        />
        <SortingWrapper className="d-flex sb">
          <Text type="b3">{pager?.total_items || 0} percorsi formativi</Text>
          <SortBy
            onChange={(v) => {
              setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
            }}
          />
        </SortingWrapper>
        {!mediaIsPhone && list?.length > 0 && (
          <Legend>
            <Text type="h3.5">Codice</Text>
            <Text type="h3.5">Percorso formativo</Text>
            <Text type="h3.5">Area tematica</Text>
            <Text type="h3.5">Stato</Text>
            <Text type="h3.5">Data di pubblicazione</Text>
          </Legend>
        )}
      </div>
      <ScrollableArea
        ref={scrollableAreaRef}
        className="fullwidth"
        style={{ minHeight: '360px' }}
      >
        {list?.length > 0 ? (
          list.map((c, i) => (
            <div key={`course-${i}`}>
              {mediaIsPhone ? (
                <CourseCardMobile>
                  <Text type="h5">Codice</Text>
                  <Text type="b4" className="code">
                    {c?.code || '-'}
                  </Text>
                  <Text type="h5">Percorso formativo</Text>
                  <Text
                    type="h3"
                    onClick={() => {
                      navigate(`${routes.editCourse.path}/${c?.id}`);
                      modalClose();
                    }}
                  >
                    {c?.title || '-'}
                  </Text>
                  <Text type="h5">Area tematica</Text>
                  <Text type="b4">{c?.thematic_area || '-'}</Text>
                  <Text type="h5">Stato</Text>
                  <Text type="b4">
                    {c?.visibility ? 'Visibile' : 'Non visibile'}
                  </Text>
                  <Text type="h5">Data di pubblicazione</Text>
                  <Text type="b5">{timestampToDate(c.publication_date)}</Text>
                </CourseCardMobile>
              ) : (
                <CourseCard>
                  <Text type="b4" className="code">
                    {c?.code || '-'}
                  </Text>
                  <Text
                    type="h3"
                    className="ellipsis"
                    onClick={() => {
                      navigate(`${routes.editCourse.path}/${c?.id}`);
                      modalClose();
                    }}
                  >
                    {c?.title || '-'}
                  </Text>
                  <Text type="b4">{c?.thematic_area || '-'}</Text>
                  <Text type="b4">
                    {c?.visibility ? 'Visibile' : 'Non visibile'}
                  </Text>
                  <Text type="b4">{timestampToDate(c?.publication_date)}</Text>
                </CourseCard>
              )}
            </div>
          ))
        ) : (
          <NoResult />
        )}
      </ScrollableArea>
      {pager?.number_of_pages > 1 ? (
        <Footer className="pb-0">
          <PagContainer>
            <Pagination
              pager={pager}
              callBack={loadMore}
              setItemsPerPage={setItemsPerPage}
            />
          </PagContainer>
        </Footer>
      ) : (
        <div />
      )}
    </Modal>
  );
};

ModalGroupCourses.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  payload: PropTypes.object,
  id: PropTypes.string,
  list: PropTypes.array,
  pager: PropTypes.object,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getGroupCourses: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { payload, id } = state.app.modal;
      const { list, pager } = state.statistics.groupCourses;
      return { payload, id, list, pager };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getGroupCourses: (filters, group_id) =>
        dispatch({ type: GROUP_COURSES_GET._REQUEST, filters, group_id }),
    })
  ),
  withMediaQueries
)(ModalGroupCourses);
